module.exports = __webpack_public_path__ + "9c8ecfeb04a4c71bc33d3d822dbd59f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/products/hat.jpg
// module id = 601
// module chunks = 0